import Image, { ImageProps } from 'next/image'
import { FunctionComponent } from 'react'
import { useI18n } from '@/hooks/use-i18n'
import { SupportedLanguages } from '@/i18n/config'

interface LocalizedFutureImageProps extends ImageProps {
  enSrc?: string | StaticImageData
  zhHantSrc?: string | StaticImageData
  jaSrc?: string | StaticImageData
}

const LocalizedImage: FunctionComponent<LocalizedFutureImageProps> = ({
  alt,
  src,
  enSrc,
  zhHantSrc,
  jaSrc,
  ...props
}) => {
  const { language } = useI18n()

  return (
    <>
      {language.i18nCode === SupportedLanguages.enUS && (
        <Image alt={alt} src={enSrc ?? src} {...props} />
      )}
      {language.i18nCode === SupportedLanguages.zhTW && (
        <Image alt={alt} src={zhHantSrc ?? src} {...props} />
      )}
      {language.i18nCode === SupportedLanguages.ja && (
        <Image alt={alt} src={jaSrc ?? src} {...props} />
      )}
    </>
  )
}

export default LocalizedImage
